export default "__VITE_ASSET__DvOLZPRP__"